import { motion } from 'motion/react';
import { SectionHeading } from '@/components/ui/SectionHeading';
import { NumberedList } from '@/components/ui/NumberedList';

type Step = { step: string; title: string; description: string };

type Props = {
  eyebrow?: string;
  title: string;
  description?: string;
  steps: Step[];
};

export function ProcessSteps({ eyebrow = 'How we work', title, description, steps }: Props) {
  return (
    <section className="px-6 md:px-12 lg:px-20 py-24 md:py-32 bg-surface">
      <div className="mx-auto max-w-[1440px] grid lg:grid-cols-[0.9fr_1.1fr] gap-14 lg:gap-20">
        <SectionHeading
          eyebrow={eyebrow}
          title={title}
          description={description}
          className="lg:sticky lg:top-32 lg:self-start"
        />
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          viewport={{ once: true, margin: '-100px' }}
        >
          <NumberedList items={steps} />
        </motion.div>
      </div>
    </section>
  );
}
